module.exports = __webpack_public_path__ + "static/media/inInputClose.a99e6f17.svg";